import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex-center absolute top-0 left-0 z-100 flex h-full w-full bg-white/50',
    loading: 'loading',
    type: ''
  },
  defaultVariants: {}
});
